import { Info } from "lucide-react";

const SOURCE_LABELS = {
  base: "Base",
  ancestry: "Ancestry",
  ancestry_flaw: "Ancestry Flaw",
  ancestry_free: "Ancestry (free pick)",
  background: "Background",
  background_free: "Background (free pick)",
  class: "Class Key Ability",
  free: "Free Boost",
  race: "Race",
  race_choice: "Race (your choice)",
};

function sourceLabel(source) {
  const levelMatch = /^level_(\d+)$/.exec(source || "");
  if (levelMatch) return `Level ${levelMatch[1]} Boost`;
  return SOURCE_LABELS[source] || source;
}

/**
 * Hover-free (tap/click works everywhere, including touch devices) breakdown of exactly why an
 * ability score ended up at its current value — every contribution from boost_history for that
 * ability, in the order it was earned, ending at the current total.
 */
export default function AbilityBreakdownPopover({ ability, history, finalValue, open, onToggle, testId }) {
  const entries = (history || []).filter((h) => h.ability === ability);
  const baseEntry = entries.find((h) => h.source === "base");
  const base = baseEntry ? baseEntry.amount : 10;
  const contributions = entries.filter((h) => h.source !== "base");

  return (
    <div className="relative inline-block">
      <button
        type="button"
        data-testid={`ability-breakdown-toggle-${ability}`}
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
        className="absolute -top-1 -right-1 text-[#f1e0c5]/30 hover:text-[#D4AF37] z-10"
        title="Why is my score this value?"
      >
        <Info className="w-3 h-3" />
      </button>
      {open && (
        <div
          data-testid={testId}
          onClick={(e) => e.stopPropagation()}
          className="absolute z-20 top-6 left-1/2 -translate-x-1/2 w-44 bg-black/95 border border-[#D4AF37]/40 rounded-lg p-2.5 text-left shadow-xl"
        >
          <p className="text-[9px] uppercase tracking-wider text-[#D4AF37] mb-1.5">Score Breakdown</p>
          <div className="space-y-0.5 text-[10px] text-[#f1e0c5]/70">
            <div className="flex justify-between"><span>Base</span><span>{base}</span></div>
            {contributions.length === 0 && <p className="text-[#f1e0c5]/30 italic pt-1">No boosts recorded yet.</p>}
            {contributions.map((c, i) => (
              <div key={i} className="flex justify-between">
                <span>{sourceLabel(c.source)}</span>
                <span className={c.amount < 0 ? "text-[#D90429]" : "text-[#4d7c0f]"}>{c.amount >= 0 ? "+" : ""}{c.amount}</span>
              </div>
            ))}
          </div>
          <div className="border-t border-white/10 mt-1.5 pt-1 flex justify-between text-[10px]">
            <span className="text-[#f1e0c5]/70">Total</span>
            <span className="text-[#D4AF37] font-semibold">{finalValue}</span>
          </div>
        </div>
      )}
    </div>
  );
}
